var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product_detail-new dashboard-card"
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    },
    on: {
      "input": _vm.onTabChange
    },
    model: {
      value: _vm.activeTabIndex,
      callback: function ($$v) {
        _vm.activeTabIndex = $$v;
      },
      expression: "activeTabIndex"
    }
  }, [_vm.policiesPlansType == 1 || _vm.policiesPlansType == 3 ? _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('i', {
          staticClass: "fas fa-wallet"
        }), _vm._v(" Self Payment ")];
      },
      proxy: true
    }], null, false, 2734802556)
  }, [_vm.currentTab === 'self_payment' && _vm.product_detail.length != 0 ? _c('div', [_c('h3', [_vm._v("Self Payment Plans")]), _c('p', [_vm._v("You are responsible for payments under this plan.")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Current Plan(s) & Premium")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Effective Date")]), _c('th', [_vm._v("Termination Date")]), _c('th', [_vm._v("Tier")]), _c('th', [_vm._v("Premium")]), _c('th', [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.product_detail, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('span', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.plan_name) + " ")])]);
    }), 0), _c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex,
        staticClass: "d-flex new-status"
      }, [_c('strong', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.status) + " ")])]);
    }), 0), _c('td', [_vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('strong', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.plan_effective_date) + " ")])]);
    }), _c('strong', [_vm._v("(Bill Date:" + _vm._s(item.bill_date) + ") ")])], 2), _c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('span', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.plan_term_date ? plan.plan_term_date : "--") + " ")])]);
    }), 0), _c('td', [_vm._v(" " + _vm._s(item.tier) + " ")]), _c('td', [parseFloat(item.monthly_premium) > 0 ? _c('div', {
      staticClass: "price-container"
    }, [_c('span', {
      staticClass: "mb-2"
    }, [_vm._v("$" + _vm._s(`${item.monthly_premium}`))])]) : _vm._e()]), _c('td', [_c('div', {
      staticClass: "action"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'PlanDetail',
          params: {
            policyID: item.policy_id
          }
        }
      }
    }, [_c('button', {
      staticClass: "view_detail"
    }, [_vm._v(" View Details ")])]), _vm._v(" "), _c('br'), item.show_terminate && !_vm.isEmployer ? _c('button', {
      staticClass: "btn-terminate",
      on: {
        "click": function ($event) {
          return _vm.showTerminateFormModel(item.policy_id);
        }
      }
    }, [_vm._v(" Terminate ")]) : _vm._e(), _c('br'), (item === null || item === void 0 ? void 0 : item.plan_history.length) > 0 ? _c('button', {
      staticClass: "view-plan-history",
      on: {
        "click": function ($event) {
          return _vm.showViewPlanHistoryModal(item);
        }
      }
    }, [_vm._v(" View Plan History ")]) : _vm._e()], 1)])]);
  }), 0)])])]) : _c('div', [_c('b-skeleton-table', {
    attrs: {
      "rows": 2,
      "columns": 6,
      "table-props": {
        bordered: _vm.none,
        striped: true
      }
    }
  })], 1)]) : _vm._e(), _vm.policiesPlansType == 2 || _vm.policiesPlansType == 3 ? _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('i', {
          staticClass: "far fa-handshake"
        }), _vm._v(" Group Sponsored ")];
      },
      proxy: true
    }], null, false, 1785098233)
  }, [_vm.currentTab === 'group_sponsored' && _vm.product_detail.length != 0 ? _c('div', [_c('h3', [_vm._v("Group Sponsored Plans")]), _c('p', [_vm._v("Your employer covers this plan's premium.")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Current Plan(s) & Premium")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Effective Date")]), _c('th', [_vm._v("Termination Date")]), _c('th', [_vm._v("Tier")]), _c('th', [_vm._v("Group Name(Sponsor)")]), _c('th', [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.product_detail, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('span', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.plan_name) + " ")])]);
    }), 0), _c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex,
        staticClass: "d-flex new-status"
      }, [_c('strong', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.status) + " ")])]);
    }), 0), _c('td', [_vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('strong', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.plan_effective_date) + " ")])]);
    }), _c('strong', [_vm._v("(Bill Date:" + _vm._s(item.bill_date) + ") ")])], 2), _c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('span', {
        class: plan.status != 'ACTIVE' ? 'plan_inactive_red' : 'plan_active'
      }, [_vm._v(" " + _vm._s(plan.plan_term_date ? plan.plan_term_date : "--") + " ")])]);
    }), 0), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" " + _vm._s(item.tier) + " ")]), _c('td', _vm._l(item.plans, function (plan, planindex) {
      return _c('p', {
        key: planindex
      }, [_c('strong', [_vm._v(_vm._s(plan.group_name ? plan.group_name : "--"))])]);
    }), 0), _c('td', {
      staticClass: "align-middle"
    }, [_c('div', {
      staticClass: "action"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'PlanDetail',
          params: {
            policyID: item.policy_id
          }
        }
      }
    }, [_c('button', {
      staticClass: "view_detail"
    }, [_vm._v(" View Details ")])])], 1)])]);
  }), 0)])])]) : _c('div', [_c('b-skeleton-table', {
    attrs: {
      "rows": 2,
      "columns": 6,
      "table-props": {
        bordered: _vm.none,
        striped: true
      }
    }
  })], 1)]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "ok-disabled": _vm.formSubmitted,
      "id": "terminate_form",
      "ok-title": "Submit",
      "centered": true,
      "title": "Terminate Plan",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.resetFormFields,
      "ok": _vm.terminatePlanPolicy
    }
  }, [_c('p', {
    staticClass: "disclaimer-text"
  }, [_vm._v("You can only select a termination date within the current month. If you wish to select a date in another month, please make your request during that month or contact our support team for assistance.")]), _c('hr'), _c('b-form-group', {
    staticClass: "required",
    attrs: {
      "label": "Term Effective Date",
      "label-for": "terminate_input_2",
      "invalid-feedback": "Term date is required."
    }
  }, [_c('b-form-select', {
    attrs: {
      "state": _vm.validateState('term_date'),
      "id": "terminate_input_2",
      "options": _vm.term_dates,
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("Select Date")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.form_policy_update.term_date.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form_policy_update.term_date, "$model", $$v);
      },
      expression: "$v.form_policy_update.term_date.$model"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Select Plan(s)",
      "label-for": "plan_checkboxes"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var ariaDescribedby = _ref.ariaDescribedby;
        return _vm._l(_vm.infoOne, function (option) {
          return _c('b-form-checkbox', {
            key: option.plan_id,
            attrs: {
              "v-if": 1 === 2,
              "state": _vm.validateState('plan_id'),
              "value": option.plan_id,
              "aria-describedby": ariaDescribedby,
              "name": "flavour-3a"
            },
            model: {
              value: _vm.$v.form_policy_update.plan_id.$model,
              callback: function ($$v) {
                _vm.$set(_vm.$v.form_policy_update.plan_id, "$model", $$v);
              },
              expression: "$v.form_policy_update.plan_id.$model"
            }
          }, [_vm._v(" " + _vm._s(option.plan_name) + " ")]);
        });
      }
    }])
  }), _c('b-form-group', {
    staticClass: "required",
    attrs: {
      "label": "Reasons",
      "label-for": "terminate_input_3",
      "invalid-feedback": "Reason is required."
    }
  }, [_c('b-form-select', {
    attrs: {
      "state": _vm.validateState('term_reason'),
      "id": "terminate_input_3",
      "options": _vm.reasons,
      "required": ""
    },
    model: {
      value: _vm.$v.form_policy_update.term_reason.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form_policy_update.term_reason, "$model", $$v);
      },
      expression: "$v.form_policy_update.term_reason.$model"
    }
  }), _vm.form_policy_update.term_reason == 'Others' ? _c('b-form-group', {
    staticClass: "required",
    attrs: {
      "label": "",
      "label-for": "other_reason",
      "invalid-feedback": "Reason is required."
    }
  }, [_c('b-form-textarea', {
    staticStyle: {
      "margin-top": "4%"
    },
    attrs: {
      "id": "other_reason",
      "state": _vm.validateState('other_reason'),
      "placeholder": "Enter reason",
      "rows": "3",
      "max-rows": "6"
    },
    model: {
      value: _vm.$v.form_policy_update.other_reason.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.form_policy_update.other_reason, "$model", $$v);
      },
      expression: "$v.form_policy_update.other_reason.$model"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "signature"
  }, [_c('div', {
    staticClass: "signature_title"
  }, [_c('p', [_vm._v(" Application Signature (Required) "), _c('span', [_vm._v("(Sign Name using your mouse or touch screen in the box below)")])])]), _c('signature-pad', {
    on: {
      "sign": _vm.getSign
    }
  }), !_vm.$v.form_policy_update.sign.required && _vm.$v.form_policy_update.sign.$error ? _c('div', {
    staticClass: "invalid-feedback",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "tabindex": "-1",
      "role": "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }
  }, [_vm._v(" Sign is required. ")]) : _vm._e(), _c('div', [_c('p', {
    staticClass: "terminate_noticed"
  }, [_vm._v(" Note : By sending this termination request you are aware that a scheduled pending payment or payment in progress cannot be altered or will not be stopped by submitting this request. ")])])], 1)], 1), _c('PlanReactivationModal', {
    attrs: {
      "current_plan": _vm.current_plan,
      "current_policy_id": _vm.current_policy_id
    },
    on: {
      "update:current_plan": function ($event) {
        _vm.current_plan = $event;
      },
      "update:current_policy_id": function ($event) {
        _vm.current_policy_id = $event;
      }
    }
  }), _c('member-plan-history-modal', {
    attrs: {
      "member": _vm.row,
      "showPlanHistoryModal": _vm.showPlanHistoryModal
    },
    on: {
      "update:member": function ($event) {
        _vm.row = $event;
      },
      "onCloseModal": function ($event) {
        _vm.row = null;
      },
      "showActivateModel": _vm.renderplanActivateModal,
      "update:showPlanHistoryModal": function ($event) {
        _vm.showPlanHistoryModal = $event;
      },
      "update:show-plan-history-modal": function ($event) {
        _vm.showPlanHistoryModal = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }